'use strict';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

export class SortMethod {
  static ASCENDING = new SortMethod('ascending', true, 'descending');
  static DESCENDING = new SortMethod('descending', false, 'none');
  static NONE = new SortMethod('none', null, 'ascending');

  constructor(name, val, next) {
    this.name = name;
    this.val = val;
    this.next = next;
  }

  static getNext(method) {
    return SortMethod.valueOf(method.next);
  }

  static valueOf(name) {
    if (isString(name)) {
      switch (name) {
        case SortMethod.ASCENDING.name:
          return SortMethod.ASCENDING;
        case SortMethod.DESCENDING.name:
          return SortMethod.DESCENDING;
        case SortMethod.NONE.name:
          return SortMethod.NONE;
      }
    } else if (name instanceof SortMethod) {
      return name;
    }
  }

  static serverVal(method) {
    const val = SortMethod.valueOf(method);
    switch (val) {
      case SortMethod.ASCENDING:
        return 'asc';
      case SortMethod.DESCENDING:
        return 'desc';
      case SortMethod.NONE:
      default:
        return null;
    }
  }

  static equals(a, b) {
    if (a === b) {
      return true;
    } else {
      const aO = isObject(a);
      const bO = isObject(b);
      if (!aO && !bO) {
        return true;
      } else if (aO !== bO) {
        return false;
      } else {
        const aM = SortMethod.valueOf(a.name);
        const bM = SortMethod.valueOf(b.name);
        return aM === bM;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/SortMethod.js